







import Vue from 'vue';

export default Vue.extend({
    name: 'NavigationalTile',
    props: {
        headingNarrative: String,
        subheadingNarrative: String,
    },
});
